import Mustache from 'lib/mustache';
import Pagination from 'mypage/pagination';
import 'mypage/event';

const $loadMoreButton = $('button#load_more');
const template = $('#body_template').html();
const $donorSearchInput = $('#mypage_list_filter_input');
const $listBody = $('.fundraising__list .list-body');

function generateNewEntries (Mustache, template) {
  return function (data) {
    let html;
    if (!data.length) {
      $('.empty-filter-message').removeClass('hidden');
    } else {
      html = data.reduce(function (a, b) {
        return a + Mustache.render(template, b);
      }, '');
    }
    return html;
  };
}

function loadedCount (selector) {
  return function () {
    const rows = $(selector).find('> li');
    return rows.length;
  };
}

let lastQuery = '';
function searchQuery (rowsSelector) {
  return function (data = '') {
    const $rows = $(rowsSelector);
    const previousQuery = lastQuery;
    lastQuery = data;

    // New query
    if (data !== previousQuery && data === '') { return {}; }
    if ($rows.length <= 0) { return { name_query: data }; }
    if (data !== previousQuery) { return { name_query: data }; }

    // Continue last query
    return {
      name_query: data
    };
  };
}

let entryGeneratorFunc;

if (template.length) {
  entryGeneratorFunc = generateNewEntries(Mustache, template);
}

const url = `/events/mypage/${window.ajaxBaseData.id}/${window.ajaxBaseData.year}/donors.json`;

if ($loadMoreButton.length && template.length) {
  const moreDataQueryFunc = searchQuery('.fundraising__list .list-body li');
  const loadedCountFunc = loadedCount('.fundraising__list .list-body');

  Pagination.loadMore($loadMoreButton, $donorSearchInput, url, moreDataQueryFunc, entryGeneratorFunc, loadedCountFunc);
}

if ($donorSearchInput.length && $listBody.length) {
  const queryFunc = searchQuery('.fundraising__list .list-body li');

  Pagination.searchField($donorSearchInput, $loadMoreButton, $listBody, url, queryFunc, entryGeneratorFunc);
}
